import type { TRuleWithTheme } from '@/styles/theme';

export const nameWithTag: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    columnGap: '0.25rem',
});
